<template>
  <b-overlay :show="loaded" rounded="sm">
    <div class="role-view">
      <div class="bg-white mt-3 p-3 activity-type-create col-12">
        <div class="d-flex title-bar-block mb-2">
          <div class="icon-block me-4">
            <button v-b-tooltip.hover :title="$backLabel()" @click="cancel()">
              <i class="fa fa-chevron-left text-white" aria-hidden="true"></i>
            </button>
          </div>
          <div class="text">
            <span class="me-2">{{ $translate("view_role") }} </span>
          </div>
        </div>
        <b-overlay :show="updating || generalDeleting" rounded="sm">
          <b-form class="form-sample" @submit.prevent="update()">
            <b-row>
              <b-col cols="12">
                <label for="input-name" class="mb-3"
                  ><strong
                    >{{ $nameLabel() }}<span class="red">*</span></strong
                  ></label
                >
                <b-form-input
                  type="text"
                  id="input-name"
                  v-model="model.name"
                  required
                  :placeholder="$translate('enter_name')"
                  trim
                ></b-form-input>
              </b-col>
              <b-col cols="12" md="2" class="mt-3 d-flex align-items-center">
                <div class="form-check me-3">
                  <label class="form-check-label">
                    <input
                      type="checkbox"
                      id="input-mobile_access"
                      v-model="model.mobile_access"
                      name="input-mobile_access"
                      :value="1"
                      :unchecked-value="0"
                    />
                    <i class="input-helper"></i>
                  </label>
                </div>
                <label
                  id="mobile_access-group"
                  for="input-mobile_access"
                  class="mb-1 ms-2"
                  ><strong> {{ $translate("mobile_access") }}</strong></label
                >
              </b-col>
              <b-col cols="12" md="2" class="mt-3 d-flex align-items-center">
                <div class="form-check me-3">
                  <label class="form-check-label">
                    <input
                      type="checkbox"
                      id="input-web_access"
                      v-model="model.web_access"
                      name="input-web_access"
                      :value="1"
                      :unchecked-value="0"
                    />
                    <i class="input-helper"></i>
                  </label>
                </div>
                <label
                  id="web_access-group"
                  for="input-web_access"
                  class="mb-1 ms-2"
                  ><strong> {{ $translate("web_access") }}</strong></label
                >
              </b-col>
              <b-col cols="12" class="my-3">
                <label class="form-control-label mb-3"
                  ><strong>{{ $translate("permissions") }}</strong></label
                >
                <permission-groups
                  v-model="model.permissions"
                ></permission-groups>
              </b-col>
              <b-col cols="12" class="my-3">
                <label class="form-control-label mb-3"
                  ><strong>{{
                    $translate("activity_type_permissions")
                  }}</strong></label
                >
                <activity-permission-groups
                  v-model="model.activity_permissions"
                ></activity-permission-groups>
              </b-col>
              <b-col cols="12" class="mt-3 d-flex gap-2 justify-content-center">
                <b-button
                  v-if="hasPermissionUpdate"
                  @click="update()"
                  variant="info"
                  size="fw"
                  :disabled="updating ? true : false"
                  >{{
                    updating
                      ? $translate("saving_changes") + "..."
                      : $translate("save_changes")
                  }}</b-button
                >
                <b-button
                  v-if="hasPermissionDelete"
                  @click="deleteRole()"
                  size="fw"
                  variant="delete-button"
                >
                  {{ $translate("delete_role") }}
                </b-button>
                <b-button
                  :disabled="updating"
                  variant="info"
                  size="fw"
                  @click="cancel()"
                >
                  {{ $cancelLabel() }}
                </b-button>
              </b-col>
            </b-row>
          </b-form>
        </b-overlay>
      </div>
    </div>
  </b-overlay>
</template>
<script>
//import Multiselect from 'vue-multiselect'
import ActivityPermissionGroups from "@/components/ActivityPermissionGroups";
import PermissionGroups from "@/components/PermissionGroups";
import popupMixins from "@/mixins/popupMixins";
import permissionsMixins from "@/mixins/permissionsMixins";
import utilityMixins from "@/mixins/utilityMixins";

export default {
  name: "roles-view",
  mixins: [popupMixins, utilityMixins, permissionsMixins],
  components: { PermissionGroups, ActivityPermissionGroups },
  data() {
    return {
      model: {
        id: 0,
        name: "",
        web_access: false,
        mobile_access: true,
        permissions: [],
        activity_permissions: [],
      },
      loaded: true,
      updating: false,
    };
  },
  computed: {
    componentName() {
      return this.$translate("role");
    },

    user_permissions() {
      return this.$store.getters.user_permissions;
    },
    role() {
      return this.$store.state.roles.item || {};
    },
    activityRole() {
      return this.$store.state.activityTypeRoles.item || {};
    },

    combinedRoles() {
      return {
        mainRole: this.role,
        activityRole: this.activityRole,
      };
    },
  },
  watch: {
    combinedRoles: {
      handler: function (val) {
        this.loaded = false;
        console.log("role changed", val);

        const { mainRole, activityRole } = val;

        const model = { ...mainRole };

        model.permissions = model.permissions.map((x) => x.permission);
        model.activity_permissions = (
          activityRole.activity_permissions || []
        ).map((x) => x.activity_permission);

        this.model = model;
      },
      deep: true,
    },
  },
  methods: {
    cancel() {
      this.$router.push("/ams/roles");
    },
    async update() {
      try {
        this.updating = true;
        const valid = await this.$validator.validate();
        if (!valid) {
          throw new Error("Not Valid");
        }

        const newModel = { ...this.model };
        console.log("newModel:", newModel);
        await this.$store.dispatch("roles/update", newModel);
        this.genericToast(
          this.componentName,
          this.$translate("updated"),
          "success",
          `${this.$translate("role")} ${this.$translate("update_alert")}`
        );
      } catch (error) {
        this.genericToast(
          this.componentName,
          this.$translate("error"),
          "danger",
          `${error.message}`
        );
      } finally {
        this.updating = false;
      }

      // this.doToast('Role Updated', 'success')
    },

    async deleteRole() {
      const model = { ...this.model };
      const routes = {
        baseRoute: "/roles",
        deleteRoute: "roles/delete",
      };
      const notificationFields = {
        type: this.$translate("role"),
        errorMsg: this.$translate("role_assign_alert"),
      };

      await this.deleteItem(notificationFields, model, routes);
    },
  },
  mounted() {
    this.$store.dispatch("permissions/all");
    this.$store.dispatch("permissions/allActivityTypePermission");

    this.$store.dispatch("roles/fetchById", this.$route.params.id);
    this.$store.dispatch("activityTypeRoles/fetchById", this.$route.params.id);
  },
};
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
